import axios from "axios";

const runtimeOrigin = typeof window !== "undefined" ? window.location.origin : "";
const backendOrigin = process.env.REACT_APP_BACKEND_URL || runtimeOrigin;
export const API = `${backendOrigin}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => config);

export const imageOptions = [
  "https://images.pexels.com/photos/15865826/pexels-photo-15865826.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.unsplash.com/photo-1599598177991-ec67b5c37318?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1470364693235-a4fe27c60914?auto=format&fit=crop&w=1200&q=85",
  "https://images.unsplash.com/photo-1641412722397-3be359096577?auto=format&fit=crop&w=1200&q=85",
];

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_bonsai-shop-3/artifacts/toy5k1rv_Bonsai%20Broker%20Logo.jpg";

export const categories = [
  { value: "bonsai_trees", label: "Bonsai Tree" },
  { value: "bonsai_pots", label: "Bonsai Pots" },
  { value: "tools", label: "Tools" },
  { value: "soil", label: "Soil" },
  { value: "wire", label: "Wire" },
  { value: "display_items", label: "Display Items" },
  { value: "display_tables", label: "Display Tables" },
  { value: "misc", label: "MISC" },
];

export const cityStateOptions = [
  "Allentown, PA", "Albuquerque, NM", "Anchorage, AK", "Asheville, NC", "Atlanta, GA", "Austin, TX", "Baltimore, MD", "Birmingham, AL", "Boise, ID", "Boston, MA", "Buffalo, NY", "Charlotte, NC", "Chicago, IL", "Cincinnati, OH", "Cleveland, OH", "Columbus, OH", "Dallas, TX", "Denver, CO", "Detroit, MI", "Honolulu, HI", "Houston, TX", "Indianapolis, IN", "Jacksonville, FL", "Kansas City, MO", "Las Vegas, NV", "Los Angeles, CA", "Louisville, KY", "Memphis, TN", "Miami, FL", "Milwaukee, WI", "Minneapolis, MN", "Nashville, TN", "New Orleans, LA", "New York, NY", "Oklahoma City, OK", "Omaha, NE", "Philadelphia, PA", "Phoenix, AZ", "Pittsburgh, PA", "Portland, OR", "Raleigh, NC", "Richmond, VA", "Sacramento, CA", "Salt Lake City, UT", "San Antonio, TX", "San Diego, CA", "San Francisco, CA", "San Jose, CA", "Santa Fe, NM", "Seattle, WA", "St. Louis, MO", "Tampa, FL", "Tucson, AZ", "Washington, DC"
];

export const TERMS_VERSION = "2026-08-02-broker-fee-5";
export const PRIVACY_VERSION = "2026-06-11";
export const BROKER_FEE_RATE = 0.05;

export const TERMS_TEXT = `BONSAI-BROKER.COM TERMS OF SERVICE AND LIABILITY DISCLAIMER

Effective Date: 6/6/2026

1. MARKETPLACE STATUS
Bonsai-Broker.com ("Bonsai-Broker," "we," "our," or "us") operates solely as an online marketplace that facilitates transactions between independent buyers and sellers. Bonsai-Broker is not the grower, owner, exporter, importer, shipper, carrier, reseller, or manufacturer of any bonsai tree, plant, pot, tool, accessory, or other item offered for sale by third-party sellers unless expressly stated otherwise.

2. NO RESPONSIBILITY FOR PRODUCTS
ALL PRODUCTS ARE SOLD DIRECTLY BY THE SELLER.
Bonsai-Broker does not inspect, verify, certify, guarantee, or warrant the condition, health, quality, authenticity, legality, packaging, shipping method, survivability, merchantability, fitness for a particular purpose, or conformity of any product listed on the platform.
Bonsai-Broker shall not be liable for damaged products, dead or unhealthy trees or plants, shipping delays, shipping damage, weather-related losses, customs seizures, seller misrepresentations, incorrect descriptions, undisclosed defects, lost packages, or any other issue relating to a product or transaction.

3. BUYER-SELLER DISPUTES
All disputes, claims, complaints, refunds, exchanges, chargebacks, warranty claims, product-condition claims, shipping claims, and post-sale issues are solely between the buyer and the seller. Users expressly agree that Bonsai-Broker has no obligation to investigate, mediate, resolve, reimburse, compensate, or participate in any dispute between users.

4. ALL SALES FINAL
Unless otherwise required by applicable law, ALL SALES ARE FINAL. Bonsai-Broker does not provide refunds, returns, exchanges, replacements, credits, guarantees, or warranties. Any return, refund, replacement, or adjustment shall be handled exclusively by the seller in accordance with the seller's stated policies.

4A. BROKERAGE FEES
Each completed transaction includes a Bonsai-Broker brokerage fee. Buyers agree to pay a 5% buyer brokerage fee calculated on the item subtotal, added at checkout. Sellers receive 100% of their listing price plus shipping through the platform payout flow unless otherwise stated in a seller-specific written agreement. Shipping charges are not included in the brokerage-fee calculation unless otherwise required by law or expressly stated by Bonsai-Broker. By using the platform, buyers and sellers acknowledge and agree to these brokerage fees.

5. DISCLAIMER OF WARRANTIES
TO THE MAXIMUM EXTENT PERMITTED BY LAW, THE PLATFORM AND ALL PRODUCTS LISTED THROUGH THE PLATFORM ARE PROVIDED "AS IS," "WITH ALL FAULTS," AND "AS AVAILABLE." BONSAI-BROKER EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, INCLUDING IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, NON-INFRINGEMENT, AND ANY WARRANTY ARISING FROM COURSE OF DEALING OR USAGE OF TRADE.

6. LIMITATION OF LIABILITY
TO THE MAXIMUM EXTENT PERMITTED BY LAW, BONSAI-BROKER SHALL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, EXEMPLARY, PUNITIVE, OR ECONOMIC DAMAGES ARISING OUT OF OR RELATED TO ANY PRODUCT, TRANSACTION, SELLER CONDUCT, BUYER CONDUCT, SHIPPING ISSUE, PLANT DEATH OR DETERIORATION, LOST PROFITS, BUSINESS INTERRUPTION, OR PLATFORM USE. IN NO EVENT SHALL BONSAI-BROKER'S TOTAL LIABILITY EXCEED ONE HUNDRED U.S. DOLLARS (US $100).

7. INDEMNIFICATION
Users agree to defend, indemnify, and hold harmless Bonsai-Broker, its owners, officers, employees, contractors, affiliates, and agents from and against any claims, lawsuits, liabilities, damages, losses, costs, and attorneys' fees arising from user transactions, seller listings, product defects, shipment issues, violations of law, or disputes between buyers and sellers.

8. RELEASE OF CLAIMS
Users knowingly and voluntarily release Bonsai-Broker from any and all claims, demands, causes of action, damages, liabilities, losses, and expenses arising from transactions conducted through the platform.

9. GOVERNING LAW
These Terms shall be governed by and construed under the laws of the State of Pennsylvania, without regard to conflict-of-law principles.

10. SEVERABILITY
If any provision of these Terms is found unenforceable, the remaining provisions shall remain in full force and effect.

11. ACKNOWLEDGMENT
By accessing or using Bonsai-Broker.com, each user acknowledges that they have read, understood, and agreed to these Terms and expressly understand that Bonsai-Broker acts solely as a venue connecting buyers and sellers and assumes no responsibility for the products sold by third parties.`;

export const PRIVACY_TEXT = `Privacy Policy

Last Updated: June 11, 2026

Bonsai Broker Privacy Policy

Bonsai Broker ("Bonsai Broker," "we," "our," or "us") is committed to protecting your privacy and maintaining the security of your personal information. This Privacy Policy explains how we collect, use, disclose, store, and protect information when you access or use the Bonsai Broker website, mobile applications, messaging services, marketplaces, and related services (collectively, the "Services").

By accessing or using our Services, you acknowledge that you have read and understood this Privacy Policy.

1. Scope

This Privacy Policy applies to all users of Bonsai Broker, including buyers, sellers, visitors, and business users located within the United States.

This Privacy Policy does not apply to third-party websites, services, payment providers, or applications that may be linked through our Services.

2. Information We Collect

We collect information directly from you, automatically through your use of the Services, and from third-party service providers.

Information You Provide

Depending on how you use Bonsai Broker, we may collect:

Account Information
Full name
Username
Email address
Phone number
Password (stored using secure hashing methods)
Profile information
Account preferences
Seller Onboarding Information

Stripe Connect may collect government-issued identification, date of birth, verification photographs, tax information, and business information as part of seller onboarding. Bonsai Broker receives Connect account status and payment capability information needed to operate the marketplace, but does not store raw identity documents or verification photographs.
Marketplace Information
Listings you create
Product descriptions
Bonsai tree information
Pricing information
Purchase history
Sales history
Shipping information
Communications relating to transactions
User Content

You may upload:

Photos
Videos
Documents
Reviews
Ratings
Profile content
Marketplace listings
Customer Support Information

When you contact us, we may collect:

Communications
Support requests
Feedback
Survey responses
3. End-to-End Encrypted Messages

Bonsai Broker provides end-to-end encrypted messaging between users.

What End-to-End Encryption Means

Messages sent through our encrypted messaging system are encrypted on the sender's device and can only be decrypted by the intended recipient.

As a result:

Bonsai Broker cannot read message contents.
Bonsai Broker cannot access message text.
Bonsai Broker cannot decrypt encrypted communications.
Message content is not used for advertising purposes.
Metadata We May Collect

Although message content remains inaccessible to us, we may collect limited metadata necessary to operate the messaging service, including:

Sender account information
Recipient account information
Message timestamps
Delivery status
Device information
Abuse and security indicators

This metadata may be used for security, fraud prevention, and service operation.

4. Information Collected Automatically

When you use the Services, we may automatically collect:

Device Information
Device type
Operating system
Browser type
Device identifiers
Log Information
IP address
Login activity
Access times
Referring URLs
Pages viewed
Actions taken within the Services
Location Information

We may collect:

Approximate geographic location derived from IP address
User-provided address information
Shipping locations
Cookies and Similar Technologies

We use cookies, pixels, local storage technologies, and similar technologies to:

Authenticate users
Maintain sessions
Remember preferences
Analyze usage
Improve functionality
Prevent fraud and abuse
5. How We Use Information

We may use collected information to:

Provide and maintain the Services
Process transactions
Facilitate marketplace activities
Enable buyer and seller communications
Verify identities
Prevent fraud
Detect abuse and security threats
Improve products and features
Personalize user experiences
Respond to support requests
Enforce our Terms of Service
Comply with legal obligations
Protect users and the public
6. Legal Bases for Processing

Where applicable under privacy laws, we process information based on:

User consent
Contractual necessity
Compliance with legal obligations
Legitimate business interests
Protection of users and platform security
7. How We Share Information

We do not sell personal information to third parties.

We may share information with:

Service Providers

Including providers supporting:

Hosting services
Cloud infrastructure
Payment processing
Customer support
Security services
Email delivery
Analytics services

These providers may only process information on our behalf and according to our instructions.

Payment Processing

Payments are processed through:

Stripe

Bonsai Broker does not store full payment card numbers. Payment information is processed and secured by Stripe in accordance with its own privacy and security practices.

Marketplace Participants

When transactions occur, certain information may be shared between buyers and sellers, including:

Name
Shipping information
Transaction details

Only information necessary to complete a transaction is shared.

Legal Compliance

We may disclose information when required to:

Comply with applicable law
Respond to lawful requests
Enforce agreements
Protect rights and safety
Prevent fraud or abuse
Business Transfers

If Bonsai Broker undergoes:

Merger
Acquisition
Asset sale
Reorganization
Bankruptcy

Information may be transferred as part of the transaction.

8. Data Retention

We retain information only as long as necessary to:

Provide Services
Complete transactions
Resolve disputes
Comply with legal obligations
Enforce agreements

Retention periods vary based on the type of information and applicable legal requirements.

Even after account closure, certain records may be retained where required by law or for legitimate business purposes.

9. Data Security

We implement administrative, technical, and physical safeguards designed to protect information from:

Unauthorized access
Disclosure
Alteration
Destruction

Security measures may include:

Encryption in transit
Encryption at rest
End-to-end encrypted messaging
Access controls
Monitoring systems
Fraud detection mechanisms
Secure payment processing

No security system can guarantee absolute security.

10. Your Privacy Rights

Depending on applicable law, users may have rights to:

Access personal information
Correct inaccurate information
Delete personal information
Restrict processing
Object to processing
Request data portability
Withdraw consent where applicable

Requests may be submitted using the contact information provided below.

We may verify identity before processing requests.

11. California Privacy Rights

If you are a California resident, you may have rights under the California Consumer Privacy Act (CCPA) and California Privacy Rights Act (CPRA), including:

Right to know
Right to access
Right to correct
Right to delete
Right to data portability
Right to limit certain uses of sensitive information
Right to non-discrimination

Bonsai Broker does not sell personal information as defined under California law.

12. Children's Privacy

The Services are not directed to children under the age of 13.

We do not knowingly collect personal information from children under 13. If we become aware that such information has been collected, we will take reasonable steps to delete it.

Parents or guardians who believe their child has provided personal information should contact us immediately.

13. User-Generated Content

Information you post publicly through:

Listings
Reviews
Ratings
Comments
Profile content

may be visible to other users and may remain accessible even after account closure where permitted by law.

Users should exercise caution when publicly sharing information.

14. Third-Party Services

The Services may contain links to third-party websites, applications, or services.

We are not responsible for:

Privacy practices
Security practices
Content
Policies

of third parties.

Users should review applicable privacy policies before interacting with third-party services.

15. United States Operations

Bonsai Broker operates within the United States.

By using the Services, you acknowledge that information may be processed and stored within the United States.

16. Changes to This Privacy Policy

We may update this Privacy Policy periodically.

When material changes occur, we will:

Update the "Last Updated" date;
Post the revised policy on the Services; and
Provide notice where required by law.

Continued use of the Services after updates constitutes acceptance of the revised Privacy Policy.

17. Contact Us

For privacy-related questions, requests, or concerns, contact:

Bonsai Broker
Pennsylvania, United States

Email: privacy@bonsai-broker.com

If you are submitting a privacy rights request, please include sufficient information for us to verify your identity and process your request.

Copyright © 2026 Bonsai Broker. All rights reserved.`;